import { render, staticRenderFns } from "./UiDialog.vue?vue&type=template&id=0db5da1a"
import script from "./UiDialog.vue?vue&type=script&lang=js"
export * from "./UiDialog.vue?vue&type=script&lang=js"
import style0 from "./UiDialog.vue?vue&type=style&index=0&id=0db5da1a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports